<template>
  <div class="add-filter-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
          <el-form-item label="过滤词名:" prop="content">
            <el-input  size="small" placeholder="请输入过滤词名" v-model="params.content"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      flag: false,
      title: '',
      dialogVisible: false,
      params: {
        content: ''
      },
      // 表单验证规则
      rules:{
        content: [{ required: true, message: '请输入过滤词名', trigger: 'blur' }],
      }
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.type === 'add') {
            this.addFilter()
          } 
        } else {
          return false;
        }
      });
    },
    // 新增过滤词
    addFilter() {
      API.filterAdd({words: [this.params.content]}).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit('handlerfilterList')
        } else {
          this.$message.error('添加失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.params = {
        words: ''
      }
    },
    // 打开新增过滤词弹窗
    open(type) {
      this.dialogVisible = true
      this.type = type
      if (type === 'add') {
        this.title = '新增过滤词'
      } 
    }
  }
}
</script>
<style scoped>

</style>